import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';

import { CART_MERCHANT_AMOUNT_BLOCK_COMPONENT } from '@core/services/cb2-preview/cb2-preview-bloc-types';
import { previewScenarioData } from '@core/services/cb2-preview/preview-scenario-data.util';
import { previewScenarioForBloc$ } from '@core/services/cb2-preview/preview-scenario-for-bloc.util';
import type { CartMerchantAmountBlockScenarioContent } from '@front-platform/content-builder';

import {
  CART_MERCHANT_AMOUNT_BLOCK_LOADING_VM,
  CartMerchantAmountBlockDataSource,
  CartMerchantAmountBlockViewModel,
} from './cart-merchant-amount-block-view-model';

function toCartMerchantAmountPreviewViewModel(
  content: CartMerchantAmountBlockScenarioContent,
): CartMerchantAmountBlockViewModel {
  return {
    orderValidateData: content.orderValidateData as unknown as
      CartMerchantAmountBlockViewModel['orderValidateData'] | null,
    isOrderValidating: content.isOrderValidating,
    cartHasProduct: content.cartHasProduct,
    orderHasProduct: content.orderHasProduct,
  };
}

@Injectable()
export class CartMerchantAmountBlockPreviewDataSource implements CartMerchantAmountBlockDataSource {
  readonly vm$: Observable<CartMerchantAmountBlockViewModel> = previewScenarioForBloc$(
    CART_MERCHANT_AMOUNT_BLOCK_COMPONENT,
  ).pipe(
    map(scenario => {
      if (!scenario) {
        return CART_MERCHANT_AMOUNT_BLOCK_LOADING_VM;
      }
      const content = previewScenarioData<CartMerchantAmountBlockScenarioContent>(
        scenario,
        CART_MERCHANT_AMOUNT_BLOCK_COMPONENT,
      );
      return content
        ? toCartMerchantAmountPreviewViewModel(content)
        : CART_MERCHANT_AMOUNT_BLOCK_LOADING_VM;
    }),
  );
}
